/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/Dashboard",
    name: "Dashboard",
    view: "Dashboard",
  },
  {
    path: "/PlaguesDashboard",
    name: "PlaguesDashboard",
    view: "PlaguesDashboard",
  },
  {
    path: "/PlaguesReports",
    name: "PlaguesReports",
    view: "PlaguesReports",
  },
  {
    path: "/Weather",
    name: "Weather",
    view: "Weather",
  },
  {
    path: "/Plagues",
    name: "Plagues",
    view: "Plagues",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    view: "UserProfile",
  },
  {
    path: "/DailyReports",
    name: "Daily Reports",
    view: "DailyReports",
  },
  {
    path: "/typography",
    view: "Typography",
  },
  {
    path: "/icons",
    view: "Icons",
  },
  {
    path: "/forecast",
    view: "Forecast",
  },
  {
    path: "/notifications",
    view: "Notifications",
  },
  {
    path: "/Configuration",
    view: "Configuration",
  },
  {
    path: "/signin",
    name: "signin",
    view: "SignIn",
  },
  { path: "/signup", view: "SignUp" },
  { path: "/admin", view: "Admin" },
  { path: "/company", view: "Company" },
  { path: "/project", view: "Project" },
  { path: "/subproject", view: "SubProject" },
  { path: "/agrounit", view: "AgroUnit" },
  { path: "/tunel", view: "Tunel" },
  { path: "/device", view: "Device" },
  { path: "/geofence", view: "Geofence" },
  { path: "/IrrigationLog", view: "IrrigationLog" },
  { path: "/Sensors", view: "Sensors" },

  { path: "/Humidity", view: "Humidity" },
  { path: "/CE", view: "CE" },
  { path: "/PH", view: "PH" },
  { path: "/Sodio", view: "Sodio" },
  { path: "/Help", view: "Help", name: "Help Center" },
  // {
  //   path: '/upgrade',
  //   name: 'Upgrade to PRO',
  //   view: 'Upgrade'
  // }
];
